export enum TankShape {
  VerticalCylinder = 'vertical-cylinder',
  HorizontalCylinder = 'horizontal-cylinder',
  HorizontalElliptical = 'horizontal-elliptical',
  RectangularPrism = 'rectangular-prism',
  MiscellaneousConsistentWidth = 'miscellaneous-consistent-width'
}
